import { z } from 'zod';
const getPastShiftsByParticipantIdParamsSchema = z.object({
    participantId: z.string().uuid(),
    missionId: z.string().uuid().optional(),
    limit: z.number().optional(),
    offset: z.number().optional(),
});
const getPastShiftsByParticipantIdResponseDataSchema = z.object({
    id: z.string().uuid(),
    created: z.number(),
    createdBy: z.string().trim().min(1),
    updated: z.number(),
    updatedBy: z.string().trim().min(1),
    columns: z.any(),
    parentId: z.string().optional(),
    permissions: z.string().array().optional(), // TODO: Change to required - CRMS-3034
});
const getPastShiftsByParticipantIdResponseSchema = z.object({
    data: getPastShiftsByParticipantIdResponseDataSchema.array(),
    total: z.number(),
    ids: z.string().uuid().array(),
});
const partialGetPastShiftsByParticipantIdResponseDataSchema = getPastShiftsByParticipantIdResponseDataSchema.omit({
    columns: true,
    permissions: true,
});
const partialGetPastShiftsByParticipantIdResponseSchema = getPastShiftsByParticipantIdResponseSchema.omit({
    data: true,
});
export const getPastShiftsByParticipantIdFunctionDef = {
    name: 'getPastShiftsByParticipantId',
    requestSchema: getPastShiftsByParticipantIdParamsSchema,
    responseSchema: getPastShiftsByParticipantIdResponseSchema,
};
